import styled from 'styled-components';

const Image = styled.img`
  width: 100%;
`;

export default Image;
